function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import isEqual from "lodash/isEqual";
import Icon from "./Icon";
var SocialMemberBubble = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(SocialMemberBubble, PureComponent);
    var _super = _createSuper(SocialMemberBubble);
    function SocialMemberBubble() {
        _classCallCheck(this, SocialMemberBubble);
        return _super.apply(this, arguments);
    }
    var _proto = SocialMemberBubble.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.fetch();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, _) {
        if (this.props.members.length <= 2 && !isEqual(prevProps.members[0], this.props.members[0])) {
            this.props.fetch();
        }
    };
    _proto.render = function render() {
        var _this_props = this.props, _this_props_members = _this_props.members, members = _this_props_members === void 0 ? [] : _this_props_members, isNote = _this_props.isNote, indicator = _this_props.indicator, isTrainerConv = _this_props.isTrainerConv, iconSize = _this_props.iconSize, avatar = _this_props.avatar;
        // INFO: every community has at least 2 members: current authenticated user
        // and another one.
        var memberIcon = isNote ? /*#__PURE__*/ React.createElement(Icon, {
            name: "notepad",
            size: iconSize
        }) : isTrainerConv ? /*#__PURE__*/ React.createElement(Icon, {
            name: "user-admin",
            size: iconSize
        }) : members.length > 2 ? /*#__PURE__*/ React.createElement(Icon, {
            name: "community",
            size: iconSize
        }) : /*#__PURE__*/ React.createElement(Icon, {
            name: "user-fill",
            size: iconSize
        });
        var scp = members[0] && members[0].name ? "scp-".concat(members[0].name.substring(0, 1).toLowerCase()) : "scp-default";
        return /*#__PURE__*/ React.createElement("span", {
            className: "social-member-bubble ".concat(scp),
            style: avatar ? {
                backgroundImage: "url(".concat(avatar, ")")
            } : {},
            "data-testid": "avatar",
            "aria-hidden": true
        }, memberIcon, indicator > 0 ? /*#__PURE__*/ React.createElement("span", {
            className: "numeral-indicator social-member-bubble__indicator"
        }, indicator) : null);
    };
    return SocialMemberBubble;
}(PureComponent);
SocialMemberBubble.defaultProps = {
    indicator: 0,
    isTrainerConv: false,
    iconSize: "m",
    isNote: false
};
export default SocialMemberBubble;
